// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"0ff0b05b","703":"101bb2d7","787":"9d22cb73"}[chunkId] + ".chunk.js";
};